import { formatMonth } from '../../utils/formatters'

export default function DateRangePicker({
  startMonth,
  endMonth,
  months,
  onStartChange,
  onEndChange,
  className = ''
}) {
  return (
    <div className={`flex flex-col sm:flex-row items-start sm:items-center gap-2 ${className}`}>
      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
          From
        </label>
        <select
          value={startMonth || ''}
          onChange={(e) => onStartChange(e.target.value || null)}
          className="select text-sm"
        >
          <option value="">Start</option>
          {months.map((month) => (
            <option key={month} value={month}>
              {formatMonth(month)}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
          To
        </label>
        <select
          value={endMonth || ''}
          onChange={(e) => onEndChange(e.target.value || null)}
          className="select text-sm"
        >
          <option value="">End</option>
          {months.map((month) => (
            <option key={month} value={month}>
              {formatMonth(month)}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
